module.exports = __webpack_public_path__ + "static/media/img_flipCards-08.26f6172a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-08.png
// module id = 443
// module chunks = 4